import Ticker from 'react-ticker';
import { Typography } from '@mui/material';

const Tickers = () => {
  return (
    <div style={{ backgroundColor: '#FF7345' }}>

      <Ticker mode='await' style={{ position: 'fixed' }}>
        {({ index }) => (
          <>
            <div style={{ backgroundColor: '#FF7345', marginTop: '3px', color: 'white' }}>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  // position: 'fixed',
                  //   marginRight: 2,
                  color: 'white',
                  font: 'normal normal normal 15px/23px Poppins',
                  opacity: '0.8',
                  padding: '0px 15px 0px 15px',

                }}
              >
                {/* UWP Website Launching Soon <></> */}
              </Typography>
            </div>
          </>
        )}
      </Ticker>
    </div>
  );
}

export default Tickers;